(function($) {

  $(document).ready(function(e){

    $('#trade-form, #profile-form, #subscription-form').submit(function(){
        var $form = $(this);
        var $inputs = $form.find("input, select, textarea");

        $inputs.removeClass('error');
        $inputs.each(function() {
            if( $(this).parent().find('label span').hasClass('required') && $(this).val().length == 0 ) {
                $(this).addClass('error');
            }

        });

        if($form.find('.error').length > 0) {
            var $errorArea = $(".woocommerce");

            // Remove element to avoid notice repetition
            $('.woocommerce-error').remove();
            $errorArea.prepend('<ul class="woocommerce-error"></ul>');

            $(".error").each(function() {
                var $error = $(this).parent().find('label')[0].childNodes[0].nodeValue;
                var $errorVal = $error.replace(':', '');

                $(".woocommerce-error").append("<li>" + $errorVal + " is required</li>");
                window.scrollTo(0, 0);
            });

            return false;
        }
    });

  });

  var intervalMenu;

  function menuCallback() {
    if ($('#menu-product-menu:visible').length > 0) { stopCallBack(); $('body').addClass('show-menu'); startInterval(); } else { stopCallBack(); $('body').removeClass('show-menu'); startInterval(); }
  }

  function stopCallBack() {
    clearInterval( intervalMenu );
  }

  function startInterval() {
    intervalMenu = window.setInterval(menuCallback, 500);
  }


  if ( $('.fl-menu-mobile-toggle').length > 0 ) {
    $('.fl-menu-responsive-toggle-mobile').prepend('<button title="Close (Esc)" type="button" class="fl-menu-mobile-toggle hamburger-override">×</button>');
    $('.fl-menu-responsive-toggle-mobile').append('<div class="overlay"></div>');
    startInterval();
  }

  $(document).on('click','.hamburger-override',function(e){
    e.preventDefault();

    if ( $('#menu-product-menu:visible').length > 0 ) {
      $('#menu-product-menu:visible').hide();
      $('#menu-product-menu:visible').removeAttr('style');
      $('body').removeClass('show-menu');
    } else {
      $('#menu-product-menu').show();
      $('body').addClass('show-menu');
    }
  });

  setTimeout(function(){
    if ($('.woocommerce-product-gallery').find('.flex-control-nav').length > 0) {
      $('.woocommerce-product-gallery').find('.flex-control-nav').slick({
        dots: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 2000,
        pauseOnFocus: false,
        fade: false,
      });
    }
  },500);

  if ( $('.widget_layered_nav_filters').find('ul').length > 0 ) {
    $('.fl-node-5a32b1127fbe9').addClass('fl-node-visible');
  }

  var submenuCategories = $('.product-categories');

  if (submenuCategories.length > 0) {

    setTimeout(function () {

      submenuCategories.find('.cat-parent').each(function(){
        $(this).append('<span class="fl-menu-toggle"></span>');
      });

      submenuCategories.find('li').not(".current-cat-parent, .current-cat").find('.children').each(function () {
        $(this).addClass('children--hidden');
      });

      submenuCategories.find('.current-cat-parent').addClass('active-list');
      submenuCategories.find('.current-cat-parent').find('.fl-menu-toggle').addClass('.fl-menu-toggle--active');

    }, 500);

    submenuCategories.on('click', '.fl-menu-toggle',function(e){
      e.preventDefault();
      $(this).toggleClass('fl-menu-toggle--active');
      $(this).parent().toggleClass('active-list');
      $(this).parent().find('> .children').toggleClass('children--hidden');
    });
  }

})(jQuery); // Fully reference jQuery after this point.
